import { HttpClient } from '@angular/common/http';
import { Component, OnInit, Query } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UsersService } from 'src/app/services/users.service';
import { NgxSpinnerService } from "ngx-spinner";


@Component({
  selector: 'app-user-contact-us',
  templateUrl: './user-contact-us.component.html',
  styleUrls: ['./user-contact-us.component.scss']
})
export class UserContactUsComponent implements OnInit {

  contactForm = new FormGroup({
    first_name: new FormControl('', Validators.required),
    last_name: new FormControl('', Validators.required),
		email: new FormControl('', [Validators.required, Validators.email,
      Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]),
    phone: new FormControl('', [Validators.required, Validators.pattern("^[0-9]*$"),Validators.minLength(10), Validators.maxLength(10)]),
    message: new FormControl('', Validators.required),
    user_id: new FormControl('',[]),
    status: new FormControl(1)
	});

  
  get f() { return this.contactForm.controls; }

  submitted = false; closeResult = '';
  errorInfo:{isError:boolean,errorMsg:string} = {isError:false,errorMsg:''}
  data={};
  adminData:any;
  userData: any;
  phoneError:string='';
  constructor(private http: HttpClient,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    public auth: UsersService,
    private modalService: NgbModal,private authUser: UsersService,
    private spinner: NgxSpinnerService,
  ) { }

  ngOnInit(): void {
    this.getIPAddress();
    this.adminData = JSON.parse(localStorage.getItem('userLoginData') || '[]');
    this.getUserList(this.adminData.user_id)
  }
	//   open(content: any) {
  //   this.modalService.open(content, { centered: true, size: 'sm' });
  // }
  getIPAddress()
  {  
    this.http.get("https://jsonip.com/").subscribe((res:any)=>{
      //console.log(res.ip);
      return res.ip;
    },
    (error)=>{
     // console.log(error);
    });
    
  }
  contactUs() {
    this.contactForm.patchValue({
      "user_id": this.adminData.user_id
    })
    this.submitted = true;
    this.spinner.show();
    this.submitted = true;
    if(this.contactForm.value.phone.length != 10 && this.contactForm.value.phone.length != 0){
      this.phoneError = 'Please input valid phone number'; 
    }else{ this.phoneError = ''; }
    
    if (this.contactForm.invalid) { return; }
    this.authUser.contact_us(this.contactForm.value).subscribe(
      (data) => {
        if (data.success == true && data.status==201) {
        //  this.router.navigateByUrl('/');
        document.getElementById('successMsg')?.click();
       // alert("Query submitted successfully")
        this.contactForm.reset()
        this.submitted = false; 
        this.getUserList(this.adminData.user_id)
        }
      }, (error) => { alert(error) },
    );
  }
  getUserList(user_id:any) {
    this.spinner.show();
    this.authUser.getQueryList(user_id).subscribe(
      (data) => {
       // console.log(data);
        if (data.success) {
          this.spinner.hide();
          this.userData = data.userData;
          // console.log(this.userData);
        } else {
          this.spinner.hide();
          this.errorInfo.isError = true;
          this.errorInfo.errorMsg = 'No data Exist'
        }
      },
      (error) => {
        this.spinner.hide();
        this.errorInfo.errorMsg = error;
      },
    );
  }
  open(content: any) {
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', centered: true }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
}
